import React from 'react';
import '../index.css';

function WidgetFooter(){
    return(
        <div className="footer-wrapper">
            <p>Powered By <a className="engyjLink" href="https://www.sabaseo.com/" target="_new">Saba SEO</a></p>
        </div>
    )
}

export default WidgetFooter;